import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Login from "../../pages/Login"
import styles from "./landing.module.scss"
import { useDispatch } from "react-redux"
import { mainSplitApi } from "../../api"
import { setLocationModal } from "../../pages/Common/commonSlice"
import { useTranslation } from "react-i18next"

const Landing = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { t: translate } = useTranslation()

    useEffect(() => {
        if (location.pathname === "/commissioning-form/auth") {
            localStorage.clear()
            dispatch(setLocationModal({ locationModal: true }))
            dispatch(mainSplitApi.util.resetApiState())
        }
    }, [location])

    return (
        <Box sx={{ display: "flex",height: "100%" }}>
            <Box className={styles.login_wrapper}>
                <Box className={styles.login_wrapper__section}>
                    <Login />
                    <Button
                        fullWidth
                        variant="outlined"
                        sx={{ width: "100%", marginBottom: "auto", backgroundColor: "#fff", height: "48px", marginTop: "15px" }}
                        startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                        onClick={() => navigate("/home")}
                    >
                        {translate("backToHome")}
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default Landing
